<template>
  <b-modal
    id="contributor-invite-modal"
    ref="contributorInviteModal"
    header-class="anchor-modal"
    title="Set Role for Contributor"
    hide-footer
  >
    You are about to invite <span class="bold-text">{{ name }}</span>
    to access your Borrower Portal account. Choose a role for that new contributor below:
    <vue-form-generator
      :schema="schema"
      :model="model"
      :options="formOptions"
      ref="inviteForm"
    ></vue-form-generator>
    {{ roleDescription }}
    <b-row>
      <b-col class="col-auto ml-auto">
        <add-asset-button
          id="add-contributor-btn"
          style-class-row="pr-3"
          button-text="Save"
          :checkbox="false"
          @submit="sendNewInvitation"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';
import helper from '@/libs/forms';
import HelpHint from '@/components/utils/hints/HelpHint';
import AddAssetButton from '@/components/utils/buttons/misc/AddAssetButton';


export default {
  components: {
    AddAssetButton,
    HelpHint,
    'vue-form-generator': VueFormGenerator.component,
  },
  props: {
    roles: Array,
    lastPocUpdate: String,
  },
  data() {
    return {
      contributor: {},
      schema: {
        fields: [],
      },
      formOptions: helper.options('team-invite-', true),
      model: {},
    };
  },
  computed: {
    name() {
      if (this.contributor) return this.contributor.name;
      return '';
    },
    user() {
      return this.$store.getters.user;
    },
    roleDescription() {
      const role = this.roles.filter(
        val => val.id === this.model.role,
      )[0];
      if (role) {
        return role.description;
      }
      return '';
    },
    selectedRole() {
      const role = this.roles.filter(
        val => val.name.toLowerCase() === this.contributor.role,
      );
      if (role) {
        return role[0];
      }
      return null;
    },
  },
  methods: {
    show(contributor) {
      this.contributor = contributor;
      this.model.role = null;
      if (this.selectedRole) {
        this.model.role = this.selectedRole.id;
      }
      this.$refs.contributorInviteModal.show();
    },
    hide() {
      this.contributor = null;
      this.role = null;
      this.model = {};
      this.$refs.contributorInviteModal.hide();
    },
    sendNewInvitation() {
      if (!this.isInviteFormValid()) {
        return;
      }
      const data = {
        point_of_contact_id: this.contributor.id,
        email: this.contributor.email,
        last_poc_update: this.lastPocUpdate,
        ...this.model,
      };

      const needNewInvite = !this.contributor.status ||
        this.contributor.status === 'disconnected' ||
        this.contributor.status === 'suspended' ||
        this.contributor.status === 'rejected';
      const url = needNewInvite ?
        `/users/${this.user.id}/poc/invite`
        : `/users/${this.user.id}/poc/update_invite`;

      if (!needNewInvite) {
        delete data.email;
      }

      this.$reqs.post(url, data)
        .then((response) => {
          this.$emit('success', response);
          this.hide();
          this.$swal({
            title: 'Success',
            text: 'Invitation sent successfully.',
            type: 'success',
          });
        })
        .catch(() => {
        });
    },
    isInviteFormValid() {
      return this.$refs.inviteForm.validate();
    },
  },
  watch: {
    contributor(newValue) {
      if (newValue) {
        this.schema = {
          fields: [
            helper.simpleSelect(
              'Role',
              'role',
              true,
              this.roles,
              null,
              6,
            ),
          ],
        };
        if (!newValue.role) {
          this.schema.fields.push(
            helper.simpleSelect(
              'Email',
              'email',
              true,
              newValue.emails || [],
              null, 6,
            ),
          );
        }
      }
    },
  },
};
</script>
<style scoped>
.bold-text {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/tabs/team_members/TeamInviteModal.vue